import HeadLine from "../components/HeadLine";
import Services from "../components/Services";
import Showcase from "../components/Showcase";
import ContactUs from "../components/ContactUs";
import Map from "../components/Map";
import WhatsAppButton from '../components/WhatsAppButton';
import Footer from "../components/Footer";
import { Box } from "@mui/material";
import { useRef, useEffect } from "react";

// Simple fade-in on scroll using Intersection Observer
function useFadeInOnScroll() {
  const ref = useRef([]);
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = 1;
            entry.target.style.transform = "translateY(0)";
            entry.target.style.transition =
              "opacity 0.8s cubic-bezier(.4,0,.2,1), transform 0.8s cubic-bezier(.4,0,.2,1)";
          }
        });
      },
      { threshold: 0.15 }
    );
    ref.current.forEach((el) => {
      if (el) {
        el.style.opacity = 0;
        el.style.transform = "translateY(48px)";
        observer.observe(el);
      }
    });
    return () => observer.disconnect();
  }, []);
  return ref;
}

function Home() {
  const fadeRefs = useFadeInOnScroll();

  return (
    <Box
      sx={{
        backgroundColor: '#05020B',
        background: 'linear-gradient(180deg, #05020B 0%, #05020B 70%, #0A2E3A 85%, #0F4559 95%, #3AC3E3 100%)',
        minHeight: '100vh',
        margin: 0,
        padding: 0,
        overflowX: 'hidden',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(ellipse at bottom, rgba(58, 195, 227, 0.1) 0%, transparent 70%)',
          pointerEvents: 'none',
        }
      }}
    >
      {/* <Header /> */}
      <HeadLine />
      {/* <BannersCarousel /> */}
      <Box
        sx={{
          margin: 0,
          padding: 0,
          width: '100%',
          position: 'relative',
          zIndex: 1
        }}
      >
        <div ref={(el) => (fadeRefs.current[0] = el)}>
          <Services />
        </div>
        <div ref={(el) => (fadeRefs.current[1] = el)}>
          <Showcase />
        </div>
        {/* <div ref={(el) => (fadeRefs.current[2] = el)}>
          <Certificates />
        </div> */}
        <div ref={(el) => (fadeRefs.current[3] = el)}>
          <ContactUs />
        </div>
      </Box>
      {/* Removido o efeito de transição do Map e Footer */}
      <Box sx={{ margin: 0, padding: 0, position: 'relative', zIndex: 1 }}>
        <Map />
      </Box>
      <WhatsAppButton />
      <Box sx={{ margin: 0, padding: 0, position: 'relative', zIndex: 1 }}>
        <Footer />
      </Box>
    </Box>
  );
}

export default Home;